// API 비즈니스 에러 코드 → 사용자 안내 메시지 매핑
// 서버 응답 형식: { code: string, message: string, status: number }
export const ERROR_CODE_MESSAGES: Record<string, string> = {
  // 데이케어 시간권
  BELOW_MIN_USE_QTY: "최소 이용 수량을 충족하지 않습니다.",
  BELOW_MIN_PURCHASE_QTY: "최소 구매 수량을 충족하지 않습니다.",
};

/**
 * axios 에러 객체에서 서버 비즈니스 에러 코드를 추출한다.
 */
export const getErrorCode = (error: unknown): string | undefined => {
  return (error as { response?: { data?: { code?: string } } })?.response?.data
    ?.code;
};

/**
 * 에러 코드에 대응하는 한글 메시지를 반환한다.
 * 매핑이 없으면 서버 message → fallback 순으로 반환한다.
 */
export const getErrorMessage = (
  error: unknown,
  fallback = "요청 처리에 실패했습니다."
): string => {
  const code = getErrorCode(error);
  if (code && ERROR_CODE_MESSAGES[code]) {
    return ERROR_CODE_MESSAGES[code];
  }
  const serverMessage = (
    error as { response?: { data?: { message?: string } } }
  )?.response?.data?.message;
  return serverMessage || fallback;
};
